import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import HeaderLinks from './HeaderLinks';
import appRoutes from 'routes/app';
import { DevBuild, DemoBuild } from '../../variables/Config'
import { YahaVersion, DigmaNetwork, Slogan } from '../../variables/DigmaDef'

export class Header extends Component{
    constructor(props){
        super(props);
        //this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        this.state = {
            sidebarExists: false
        };
    }
    mobileSidebarToggle = (e) => {
        if(this.state.sidebarExists === false){
            this.setState({
                sidebarExists : true
            });

        }
        e.preventDefault();
        document.documentElement.classList.toggle('nav-open');
        var node = document.createElement('div');
        node.id = 'bodyClick';
        node.onclick = function(){
            this.parentElement.removeChild(this);
            document.documentElement.classList.toggle('nav-open');
        };
        document.body.appendChild(node);
    }
    getBrand(){
        var name;
        appRoutes.map((prop,key) => {
            if(prop.collapse){
                 prop.views.map((prop,key) => {
                    if(prop.path === this.props.location.pathname){
                        name = prop.name;
                    }
                    return null;
                })
            } else {
                if(prop.redirect){
                    if(prop.path === this.props.location.pathname){
                        name = prop.name;
                    }
                }else{
                    if(prop.path === this.props.location.pathname){
                        name = prop.name;
                    }
                }
            }
            return null;
        })
        return name;
    }
    render(){
        return (
            <Navbar fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="/#/dashboard" title={this.getBrand()}>{"לוח בקרה"}</a>
                        <span className="version-build">({YahaVersion+(DevBuild?'d':DemoBuild?'demo':"")})</span>
                        <div className="hello-user">שלום {this.props.mbouser.user_display_name}</div>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle}/>
                </Navbar.Header>
                <Navbar.Collapse>
                    <HeaderLinks userRole={this.props.mbouser.user_role[0]} hostUrl={this.props.hosturl}/>
                    <div className="yahav-main-title">
                        {Slogan}
                       {/*DemoBuild ? <h3>תיעוד  &bull;  מדידות  &bull;  תוצאות</h3>
                        : <h3>יחד  &bull;  המשפחה  &bull;  בצמיחה</h3>
                       */}
                       { DigmaNetwork ? <span >{this.props.hosturl}</span> : null }
                    </div>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

//export default Header;
